<template>
    <!-- 西安的海关 -->
    <div>
        <span>
            <a-tag v-if="!props.value">未填写</a-tag>
            <span v-else>
                {{ props.value.enfullco }}
            </span>
            <a-divider type="vertical"></a-divider>
            <a-button type="primary" size="small" @click="handleSet">填写</a-button>
            <a-divider type="vertical"></a-divider>
            <a-button type="primary" size="small" danger @click="handleDel">删除</a-button>
        </span>
    </div>
    <a-modal title="设置海关信息" :width="1000" :open="state.formVisible" @cancel="handleCancel">
        <template #footer>
            <a-button @click="handleCancel">取消</a-button>
            <a-button type="primary" @click="onFormSubmit">确定</a-button>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item name="cusname" label="注册海关" required>
                    <a-select v-model:value="formData.cusname" placeholder="请选择">
                        <a-select-option value="9001">西安陆港</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item name="specialtradezone" label="特殊贸易区域" required>
                    <a-select v-model:value="formData.specialtradezone" placeholder="请选择">
                        <a-select-option value="61019291">陕西航天经济技术开发区</a-select-option>
                        <a-select-option value="61019391">西安高新技术产业开发区其他地区</a-select-option>
                        <a-select-option value="61019961">西安航空基地综合保税区</a-select-option>
                        <a-select-option value="61019999">西安市其他地区</a-select-option>
                        <a-select-option value="6101F351">陕西自贸区中心片区西安出口加工区B区</a-select-option>
                        <a-select-option value="6101F361">陕西自贸区中心片区西安高新区综合保税区</a-select-option>
                        <a-select-option value="6101F391">陕西自贸区中心片区西安高新区其他地区</a-select-option>
                        <a-select-option value="6101F951">陕西自贸区中心片区西安出口加工区A区</a-select-option>
                        <a-select-option value="6101F991">陕西自贸区中心片区其他地区</a-select-option>
                        <a-select-option value="6101F992">陕西自贸区西安国际港务片区其他地区</a-select-option>
                        <a-select-option value="61029999">铜川市</a-select-option>
                        <a-select-option value="61049391">杨陵农业高新技术产业示范区其他地区</a-select-option>
                        <a-select-option value="61049999">咸阳市其他地区</a-select-option>
                        <a-select-option value="6104F391">陕西自贸区杨陵示范区片区</a-select-option>
                        <a-select-option value="61089999">商洛市</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item name="apanageregion" label="经济区划" required>
                    <a-select v-model:value="formData.apanageregion" placeholder="请选择">
                        <a-select-option value="02">经济技术开发全区</a-select-option>
                        <a-select-option value="03">高新技术产业开发区</a-select-option>
                        <a-select-option value="05">出口加工区</a-select-option>
                        <a-select-option value="06">保税港区/综合保税区</a-select-option>
                        <a-select-option value="09">一般经济区域</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item name="enfullco" label="英文名称" required>
                    <a-input placeholder="英文名称" v-model:value="formData.enfullco"></a-input>
                </a-form-item>
                <a-form-item name="enaddrco" label="英文地址" required>
                    <a-input placeholder="英文名称" v-model:value="formData.enaddrco"></a-input>
                </a-form-item>
                <a-form-item name="entcat" label="企业类别" required>
                    <a-checkbox-group v-model:value="formData.entcat">
                        <a-checkbox value="01">外贸企业</a-checkbox>
                        <a-checkbox value="02">有自营权的生产企业</a-checkbox>
                        <a-checkbox value="03">集装箱场站</a-checkbox>
                        <a-checkbox value="04">注册厂（库）</a-checkbox>
                        <a-checkbox value="05">出口货物生产企业</a-checkbox>
                        <a-checkbox value="06">熏蒸单位</a-checkbox>
                        <a-checkbox value="07">国内定点加工厂</a-checkbox>
                        <a-checkbox value="08">国外定点加工厂</a-checkbox>
                        <a-checkbox value="09">配餐料使用单位</a-checkbox>
                        <a-checkbox value="10">进境动物产品仓储单位</a-checkbox>
                        <a-checkbox value="11">出境动物产品仓储单位</a-checkbox>
                        <a-checkbox value="12">进境动物产品运输单位</a-checkbox>
                        <a-checkbox value="13">出境动物产品运输单位</a-checkbox>
                        <a-checkbox value="14">进境动物隔离场</a-checkbox>
                        <a-checkbox value="15">出境动物隔离场</a-checkbox>
                        <a-checkbox value="16">进境动物养殖场</a-checkbox>
                        <a-checkbox value="17">出境动物养殖场</a-checkbox>
                        <a-checkbox value="18">进境植物产品仓储单位</a-checkbox>
                        <a-checkbox value="19">出境植物产品仓储单位</a-checkbox>
                        <a-checkbox value="20">进境植物产品运输单位</a-checkbox>
                        <a-checkbox value="21">出境植物产品运输单位</a-checkbox>
                        <a-checkbox value="22">进境植物隔离场</a-checkbox>
                        <a-checkbox value="23">出境植物隔离场</a-checkbox>
                        <a-checkbox value="24">进境植物种植场</a-checkbox>
                        <a-checkbox value="25">出境植物种植场</a-checkbox>
                        <a-checkbox value="26">其他</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <!-- 人员表格 -->
                <div class="share-ownership" style="margin-top: 10px;">
                    <a-table class="ownership-table" :columns="personColumns" :data-source="formData.qszba_person"
                        :pagination="false">
                        <template #bodyCell="{ column, record, index, text }">
                            <template v-if="column.dataIndex === 'custype'">
                                {{ state.custypelist[text] }}
                            </template>
                            <template v-if="column.dataIndex === 'options'">
                                <div>
                                    <a-button @click="editPerson(record, index)" type="primary" size="small"
                                        class="mr-1x">编辑</a-button>
                                    <a-popconfirm title="确定删除?" @confirm="deletePerson(index)">
                                        <a-button size="small" type="primary" danger>删除</a-button>
                                    </a-popconfirm>
                                </div>
                            </template>
                        </template>
                    </a-table>
                    <a-button class="add-button" type="primary" @click="addPerson"
                        :icon="h(PlusOutlined)">添加人员</a-button>
                </div>
            </a-form>
        </a-skeleton>
        <!-- 添加人员 -->
        <a-modal v-model:visible="state.personVisible" title="添加人员" @ok="personOk" @cancel="personCancel">
            <a-form :model="presonData" ref="personFormRef" v-bind="formLayout">
                <a-form-item label="姓名" name="name" required>
                    <a-input v-model:value="presonData.name" />
                </a-form-item>
                <a-form-item label="证件类型" name="custype" required>
                    <a-select v-model:value="presonData.custype" placeholder="请选择">
                        <a-select-option value="1">居民身份证</a-select-option>
                        <a-select-option value="4">外国(地区)护照</a-select-option>
                        <a-select-option value="9">其他有效身份证件</a-select-option>
                        <a-select-option value="2">军官证</a-select-option>
                        <a-select-option value="3">警官证</a-select-option>
                        <a-select-option value="63">港澳居民居住证</a-select-option>
                        <a-select-option value="64">台湾居民居住证</a-select-option>
                        <a-select-option value="51">香港特别行政区护照</a-select-option>
                        <a-select-option value="52">香港（永久性）居民身份证</a-select-option>
                        <a-select-option value="53">澳门特别行政区护照</a-select-option>
                        <a-select-option value="54">澳门（永久性）居民身份证</a-select-option>
                        <a-select-option value="57">台湾居民来往大陆通行证</a-select-option>
                        <a-select-option value="58">台湾农民身份有关证明</a-select-option>
                        <a-select-option value="60">户口薄</a-select-option>
                        <a-select-option value="61">外国人永久居留身份证</a-select-option>
                        <a-select-option value="55">港澳居民往来内地通行证</a-select-option>
                        <a-select-option value="62">华侨护照</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="证件号码" name="cuscode" required>
                    <a-input v-model:value="presonData.cuscode" />
                </a-form-item>
            </a-form>
        </a-modal>
    </a-modal>

</template>
<script lang="ts" setup>
import { reactive, watch, onMounted, ref, h } from 'vue'
import { message } from 'ant-design-vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import { addAbortSignal } from 'stream'
const props = defineProps({
    value: {
        type: Object,
        default: () => { }
    }
})
const emit = defineEmits(['update:value', 'change'])
interface Person {
    name: string
    custype: string
    cuscode: string
}
interface IformData {
    cusname: string
    specialtradezone: string
    apanageregion: string
    enfullco: string
    enaddrco: string
    entcat: any[]
    qszba_person: Array<Person>
}
const formData = reactive<IformData>({
    cusname: '',
    specialtradezone: '',
    apanageregion: '',
    enfullco: '',
    enaddrco: '',
    entcat: [],
    qszba_person: [],
})
interface state {
    formVisible: boolean
    loading: boolean
    personVisible: boolean
    personIndex: number
    custypelist: any
}
const state = reactive<state>({
    formVisible: false,
    loading: false,
    personVisible: false,
    personIndex: -1,
    custypelist: {
        '1': '居民身份证',
        '4': '外国(地区)护照',
        '9': '其他有效身份证件',
        '2': '军官证',
        '3': '警官证',
        '63': '港澳居民居住证',
        '64': '台湾居民居住证',
        '51': '香港特别行政区护照',
        '52': '香港（永久性）居民身份证',
        '53': '澳门特别行政区护照',
        '54': '澳门（永久性）居民身份证',
        '57': '台湾居民来往大陆通行证',
        '58': '台湾农民身份有关证明',
        '60': '户口薄',
        '61': '外国人永久居留身份证',
        '55': '港澳居民往来内地通行证',
        '62': '华侨护照',
    }
})

const handleSet = () => {
    state.formVisible = true
    let val = props.value
    if (val) {
        formData.cusname = val.cusname
        formData.specialtradezone = val.specialtradezone
        formData.apanageregion = val.apanageregion
        formData.enfullco = val.enfullco
        formData.enaddrco = val.enaddrco
        formData.entcat = val.entcat
        formData.qszba_person = val.qszba_person
    } else {
        formData.cusname = ''
        formData.specialtradezone = ''
        formData.apanageregion = ''
        formData.enfullco = ''
        formData.enaddrco = ''
        formData.entcat = []
        formData.qszba_person = []
    }
}
const handleCancel = () => {
    state.formVisible = false
}
const onFormSubmit = () => {
    if (formData.qszba_person.length == 0) {
        message.warn('请添加报关人员')
        return
    }
    ruleForm.value
        .validate()
        .then((res) => {
            state.formVisible = false
            handleChange()
        })
        .catch((res) => {
            message.warn('请检查必填项')
        })
}
onMounted(() => {
})
// 回写回去
const handleChange = () => {
    let haiguan = {
        cusname: formData.cusname,
        specialtradezone: formData.specialtradezone,
        apanageregion: formData.apanageregion,
        enfullco: formData.enfullco,
        enaddrco: formData.enaddrco,
        entcat: formData.entcat,
        qszba_person: formData.qszba_person
    }
    emit('update:value', haiguan)
    emit('change', haiguan)
}
const handleDel = () => {
    state.formVisible = false
    emit('update:value', null)
    emit('change', null)
}
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
    }
}
const ruleForm = ref()
// 报关人员表格
const personColumns = [
    {
        title: '报关人员姓名',
        dataIndex: 'name',
        width: 140
    },
    {
        title: '证件类型',
        dataIndex: 'custype',
        width: 200
    },
    {
        title: '证件号码',
        dataIndex: 'cuscode',
        width: 250
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 200
    }
]
const personFormRef = ref()
const presonData = reactive<Person>({
    name: '',
    custype: '',
    cuscode: ''
})
const addPerson = () => {
    presonData.cuscode = ''
    presonData.custype = ''
    presonData.name = ''
    state.personVisible = true
    state.personIndex = -1
}
const editPerson = (record: any, index: number) => {
    presonData.cuscode = record.cuscode
    presonData.custype = record.custype
    presonData.name = record.name
    state.personVisible = true
    state.personIndex = index
}
const deletePerson = (index: number) => {
    formData.qszba_person.splice(index, 1)
    handleChange()
}
const personOk = () => {
    personFormRef.value
        .validate()
        .then((res) => {
            state.personVisible = false
            if (state.personIndex == -1) {
                formData.qszba_person.push({ ...presonData })
            } else {
                formData.qszba_person[state.personIndex] = { ...presonData }
            }
            handleChange()
        })
        .catch((res) => {
            message.warn('请检查必填项')
        })
}
const personCancel = () => {
    state.personVisible = false
}
</script>
<style lang="less" scoped>
.share-ownership {
    min-width: 800px;
    margin-top: 50px;
    position: relative;
    display: flex;
    justify-content: center;

    .ownership-table {
        margin-bottom: 30px;
        width: 90%;
    }
}

.add-button {
    position: absolute;
    right: 70px;
    top: 10px;
}
</style>
